import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subject } from "rxjs";
// Modules
import { ModalSize, SystemApiService } from "@cv-invision/core";
// Models
import { IntegrationsUrlParamsModel } from "../generic-integrations/models/integrations-url-params.model";
import { TenantConfigModel } from "./model/tenant.model";
import { TenantAssociationService } from "./service/tenant-association.service";

@Component({
	selector: 'cv-tenant-asssociation',
	styleUrls: ['./tenant-association.component.scss'],
	templateUrl: './tenant-association.component.html',
})
export class TenantAssociationComponent implements OnInit, OnDestroy {
	label = 'Tenant Association'
	modalSize = ModalSize.LG;
	extraData: any;
	model: any;
	tenantAssetsParams: IntegrationsUrlParamsModel;

	private atComponentDestroy: Subject<any> = new Subject<any>();

	constructor(
		private tenantAssociationService: TenantAssociationService,
		private systemApiService: SystemApiService
	) {

	}

	async ngOnInit(): Promise<void> {
		this.extraData = {
			editInModal: true,
			isExternalIntegration: true,
			showSelect: false,
			saveAsObject: true,
			deliveryAssets: {}
		};

		this.model = TenantConfigModel;

		this.tenantAssetsParams = new IntegrationsUrlParamsModel();
		this.tenantAssetsParams.isExternalIntegration = true;
		this.tenantAssetsParams.customUrl = 'tenant-configuration?limit=1000';
		this.tenantAssetsParams.customSaveUrl = 'tenant-configuration';
		await this.loadStoreData();

	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}

	loadStoreData(): Promise<void> {
		this.extraData.rootUrl = this.systemApiService.api.orders;
		this.tenantAssociationService.getIntegrations().subscribe(response => {
			const integrationTypeOptions = response.map((item: any) => {
				return {
					label: item.integrationName,
					value: item.integrationId,
				};
			});
			this.model['formBuilderConfig']['integrationId']['options'] = integrationTypeOptions;
		});
		return new Promise((resolve, reject) => {
			resolve();
		})
	}
}
